var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.26,
    height: 11.99,
    viewBox: "0 0 11.26 11.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "transcribe",
    transform: "translate(-616.696 -394.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6784",
    "data-name": "Path 6784",
    d: "M619.446,403.655v-2.55a1.6,1.6,0,0,1,1.6-1.59h5.24v-1.74l-3.59-3.6h-4.8a1.2,1.2,0,0,0-1.19,1.2l-.01,9.59a1.2,1.2,0,0,0,1.2,1.2h7.2a1.18,1.18,0,0,0,1.15-.91h-5.2A1.6,1.6,0,0,1,619.446,403.655Zm2.65-8.58,3.3,3.3h-3.3Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6785",
    "data-name": "Path 6785",
    d: "M622.026,401.285h-.01c-.04.17-.09.34-.14.51l-.28.83h.85l-.27-.82A4.745,4.745,0,0,1,622.026,401.285Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6786",
    "data-name": "Path 6786",
    d: "M626.856,400.015h-5.81a1.1,1.1,0,0,0-1.1,1.09v2.55a1.1,1.1,0,0,0,1.1,1.1h5.81a1.1,1.1,0,0,0,1.1-1.1v-2.55A1.1,1.1,0,0,0,626.856,400.015Zm-1.59.94h1.51a.254.254,0,0,1,.25.25.248.248,0,0,1-.25.25h-1.51a.248.248,0,0,1-.25-.25A.254.254,0,0,1,625.266,400.955Zm-2.44,2.85-.3-.89h-1.01l-.3.89h-.38l.97-2.85h.45l.97,2.85Zm2.57,0h-1.57a.25.25,0,0,1,0-.5h1.57a.25.25,0,0,1,0,.5Zm1.42-.78h-3.06a.25.25,0,0,1,0-.5h3.06a.25.25,0,0,1,0,.5Zm0-.79h-3.06a.245.245,0,1,1,0-.49h3.06a.245.245,0,0,1,0,.49Z",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscribe);
export default __webpack_public_path__ + "static/media/transcribe.a4153468f7030ceb4fabf8a0922b9858.svg";
export { ForwardRef as ReactComponent };